import React from "react";
import { useLocation, Outlet, Navigate } from "react-router";
import { useAppSelector } from "../redux";
import HIDCustomLogo from "./auth/login/HIDCustomLogo";
import { Button, Loader, LoaderSizes } from "@hid-galaxy-ui/galaxy-react";
import useLogoutHandler from "../hooks/useLogoutHandler";
import useInactivityTimeout from "../hooks/useInactivityTimeout";
import { useIsHidStaff } from "../hooks/useIsHidStaff";
import {
  useSessionPermissionsLoaded,
  useSessionPermissionsLoading,
} from "../hooks/useSessionPermissions";
import "./LandingPage.scss";

const LandingPage: React.FC<{}> = () => {
  const location = useLocation();
  const pathName = location.pathname.split("");
  const { loggedUserDetail, status } = useAppSelector((state) => state.auth);
  const isAdminPortal = useIsHidStaff();
  const sessionPermissionsLoading = useSessionPermissionsLoading();
  const sessionPermissionsLoaded = useSessionPermissionsLoaded();
  const [triggerLogout] = useLogoutHandler();

  const hasUserIdentity = Boolean(
    loggedUserDetail?.role || loggedUserDetail?.role_id
  );
  const awaitingSessionPermissions =
    Boolean(loggedUserDetail?.role_id) &&
    !loggedUserDetail?.role &&
    !loggedUserDetail?.role_type &&
    sessionPermissionsLoading &&
    !sessionPermissionsLoaded;

  const inactivityTimeoutHandler = () => {
    triggerLogout();
  };

  useInactivityTimeout(inactivityTimeoutHandler);

  if (status.loggedUserDetailLoading || awaitingSessionPermissions) {
    return (
      <div className="signing-in-container">
        <div className="logo-wrapper">
          <HIDCustomLogo />
        </div>
        <div className="message-box">
          <Loader variant={LoaderSizes.medium} />
          <p>Signing in to Partner Portal...</p>
        </div>
      </div>
    );
  } else if (!hasUserIdentity || loggedUserDetail?.status === "Disable") {
    return (
      <div className="signing-in-container">
        <div className="logo-wrapper">
          <HIDCustomLogo />
        </div>
        <div className="message-box">
          <p>
            {loggedUserDetail?.status === "Disable"
              ? "Account disabled"
              : "Failed to get user data"}
          </p>
          <Button
            variant="primary"
            label="Sign out"
            onClick={() => triggerLogout()}
          />
        </div>
      </div>
    );
  } else if (
    !isAdminPortal &&
    loggedUserDetail.metadata?.partner == null
  ) {
    return (
      <div className="signing-in-container">
        <div className="logo-wrapper">
          <HIDCustomLogo />
        </div>
        <div className="message-box">
          <p>No partner organization is assigned to this account.</p>
          <Button
            variant="primary"
            label="Sign out"
            onClick={() => triggerLogout()}
          />
        </div>
      </div>
    );
  }

  return (
    <>
      {pathName.includes("/") && pathName.length === 1 ? (
        <Navigate
          to={
            isAdminPortal
              ? "/hid-admin"
              : `/partner/${loggedUserDetail.metadata.partner}`
          }
        />
      ) : (
        <Outlet />
      )}
    </>
  );
};

export default LandingPage;
